<template>
    <base-tippy
        class="mx-0.5 self-center"
        placement="bottom-end"
    >
        <base-icon
            icon="asterisk"
            size="sm"
        ></base-icon>
        <template #content>
            <div class="px-2">
                <span>Informations manquantes :</span>
                <ul class="list-none">
                    <li
                        v-for="(missing, index) of translatedMissing"
                        :key="index"
                        v-text="missing"
                    ></li>
                </ul>
            </div>
        </template>
    </base-tippy>
</template>

<script>
import BaseIcon from '../Base/BaseIcon'
import BaseTippy from '../Base/BaseTippy'

export default {
  name: 'MissingInformations',
  components: {
    BaseTippy,
    BaseIcon
  },
  props: {
    translatedMissing: {
      required: true
    }
  }
}
</script>

<style scoped>

</style>
